/**
 * DEBUG-restart-algorithm-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeubgRestartAlgorithmRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DBG_REQ_RESTART_ALGORITHM;
	public static tag : MessageTag = MessageTag.DBG_REQ_RESTART_ALGORITHM;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/debug/DEBUG-restart-algorithm-request.ts